var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.22 96.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.48 5.62 69.6 5.62 69.6 18.26 75.22 18.26 75.22 0 22.48 0 22.48 5.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.62 78.12 0 78.12 0 96.47 52.74 96.47 52.74 90.85 5.62 90.85 5.62 78.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "69.6 90.85 58.82 90.85 58.82 96.47 75.22 96.47 75.22 25.56 69.6 25.56 69.6 90.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.62 5.62 16.4 5.62 16.4 0 0 0 0 70.82 5.62 70.82 5.62 5.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.33 45.47 31.96 39.64 49.03 39.64 51.82 34.8 23.62 34.8 32.56 50.27 35.33 45.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "56.15 34.8 39.89 63.05 42.66 67.85 61.74 34.8 56.15 34.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.01 43.52 32.56 58.17 19.07 34.8 13.47 34.8 32.56 67.85 46.6 43.52 41.01 43.52"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/symbol.52f051d1309cb174072c39bbb62d6209.svg";
export { ForwardRef as ReactComponent };